import type { Plugin } from "../../core/plugin";
import { PluginRegistry } from "../../core/pluginRegistry";

export class ItineraryForm implements Plugin {
  private currentPanel: "pax" | "resume" = "pax";

  private readonly formElement: HTMLFormElement;
  private readonly paxSection: HTMLElement;
  private readonly resumeSection: HTMLElement;
  private readonly saveButton: HTMLButtonElement;
  private readonly backButton: HTMLButtonElement;

  constructor(private readonly element: HTMLElement) {
    this.formElement = this.element.querySelector(
      ".dsc-co-travelpricer-itinerary-form__form",
    ) as HTMLFormElement;
    this.paxSection = this.element.querySelector(
      '[data-panel="pax"]',
    ) as HTMLElement;
    this.resumeSection = this.element.querySelector(
      '[data-panel="resume"]',
    ) as HTMLElement;
    this.saveButton = this.element.querySelector(
      '[data-action="save"]',
    ) as HTMLButtonElement;
    this.backButton = this.element.querySelector(
      '[data-action="back"]',
    ) as HTMLButtonElement;

    if (
      !this.formElement ||
      !this.paxSection ||
      !this.resumeSection ||
      !this.saveButton ||
      !this.backButton
    ) {
      throw new Error("Required form elements not found");
    }
  }

  init(): void {
    this.bindEvents();
    this.updateUI();
  }

  destroy(): void {
    this.saveButton.removeEventListener("click", this.handleSaveClick);
    this.backButton.removeEventListener("click", this.handleBackClick);
  }

  private bindEvents(): void {
    this.saveButton.addEventListener("click", this.handleSaveClick);
    this.backButton.addEventListener("click", this.handleBackClick);
  }

  private readonly handleSaveClick = (): void => {
    this.currentPanel = "resume";
    this.updateUI();
  };

  private readonly handleBackClick = (): void => {
    this.currentPanel = "pax";
    this.updateUI();
  };

  private updateUI(): void {
    // Show/hide panels
    if (this.currentPanel === "pax") {
      this.showPanel(this.paxSection);
      this.hidePanel(this.resumeSection);
    } else {
      this.hidePanel(this.paxSection);
      this.showPanel(this.resumeSection);
    }
  }

  private showPanel(panel: HTMLElement): void {
    panel.classList.remove(
      "dsc-co-travelpricer-itinerary-form__section--hidden",
    );
    panel.classList.add("dsc-co-travelpricer-itinerary-form__section--visible");

    // Add transition animation
    panel.classList.add(
      "dsc-co-travelpricer-itinerary-form__section--entering",
    );
    panel.classList.add(
      "dsc-co-travelpricer-itinerary-form__section--enter-start",
    );

    requestAnimationFrame(() => {
      panel.classList.remove(
        "dsc-co-travelpricer-itinerary-form__section--enter-start",
      );
      panel.classList.add(
        "dsc-co-travelpricer-itinerary-form__section--enter-end",
      );
    });
  }

  private hidePanel(panel: HTMLElement): void {
    panel.classList.add("dsc-co-travelpricer-itinerary-form__section--hidden");
    panel.classList.remove(
      "dsc-co-travelpricer-itinerary-form__section--visible",
    );
    panel.classList.remove(
      "dsc-co-travelpricer-itinerary-form__section--entering",
    );
    panel.classList.remove(
      "dsc-co-travelpricer-itinerary-form__section--enter-start",
    );
    panel.classList.remove(
      "dsc-co-travelpricer-itinerary-form__section--enter-end",
    );
  }
}

PluginRegistry.register("itinerary-form", ItineraryForm);
